import React from 'react';
export const Logo = ({
  className = ''
}) => {
  return <div className={`flex items-center ${className}`} data-id="element-133">
      <div className="mr-2" data-id="element-134">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-135">
          <rect width="40" height="40" rx="8" fill="#881337" data-id="element-136" />
          <path d="M10 20C10 14.477 14.477 10 20 10C25.523 10 30 14.477 30 20C30 25.523 25.523 30 20 30C14.477 30 10 25.523 10 20Z" fill="#FBBF24" data-id="element-137" />
          <path d="M16 18H24M16 22H24" stroke="#881337" strokeWidth="2" strokeLinecap="round" data-id="element-138" />
          <path d="M20 13V27" stroke="#881337" strokeWidth="2" strokeLinecap="round" data-id="element-139" />
        </svg>
      </div>
      <div className="font-bold text-xl text-rose-900" data-id="element-140">Suretask</div>
    </div>;
};